import { ActionType } from 'typesafe-actions'
import { VsInfo } from 'types/global'
import {
  COMMON_MATCHES_RESET,
  COMMON_MATCHES_REQUESTED,
  COMMON_MATCHES_COMPLETED,
  COMMON_MATCHES_FAILED,
  VS_INFO_REQUESTED,
  VS_INFO_COMPLETED,
  VS_INFO_FAILED,
  COMMON_COMPETITORS_REQUESTED,
  COMMON_COMPETITORS_COMPLETED,
  COMMON_COMPETITORS_FAILED,
  COMMON_COMPETITORS_TIME_FILTER_UPDATED,
  VS_PLAYER_IDS_UPDATED,
} from 'actions/h2h-actions'
import * as actions from 'actions/h2h-actions'

type H2HAction = ActionType<typeof actions>

export type State = Readonly<{
  commonMatches: any[]
  commonCompetitorsMatches: any[]
  commonCompetitorsTimePeriodFilter: number | null
  commonCompetitorsLoading: boolean
  commonMatchesLoading: boolean
  commonMatchesTotal?: number
  vsInfo?: VsInfo
  vsInfoLoading: boolean
  vsPlayerIds: [string, string]
}>

const initialState: State = {
  commonMatches: [],
  commonCompetitorsMatches: [],
  commonCompetitorsTimePeriodFilter: 31536000000 /* initial time period filter equals to 12 months */,
  commonCompetitorsLoading: false,
  commonMatchesLoading: false,
  vsInfoLoading: false,
  vsPlayerIds: ['', ''],
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: H2HAction): State {
  switch (action.type) {
    case COMMON_MATCHES_REQUESTED:
      return { ...state, commonMatchesLoading: true }
    case COMMON_MATCHES_COMPLETED:
      return {
        ...state,
        commonMatches: [...state.commonMatches, ...action.payload.matches],
        commonMatchesTotal: action.payload.count,
        commonMatchesLoading: false,
      }
    case COMMON_MATCHES_FAILED:
      return { ...state, commonMatchesLoading: false }
    case COMMON_MATCHES_RESET:
      return {
        ...state,
        commonMatches: initialState.commonMatches,
        commonMatchesTotal: initialState.commonMatchesTotal,
      }
    case COMMON_COMPETITORS_REQUESTED:
      return { ...state, commonCompetitorsLoading: true }
    case COMMON_COMPETITORS_COMPLETED:
      return { ...state, commonCompetitorsMatches: action.payload, commonCompetitorsLoading: false }
    case COMMON_COMPETITORS_FAILED:
      return { ...state, commonCompetitorsLoading: false }
    case COMMON_COMPETITORS_TIME_FILTER_UPDATED:
      return { ...state, commonCompetitorsTimePeriodFilter: action.payload }
    case VS_INFO_REQUESTED:
      return { ...state, vsInfoLoading: true }
    case VS_INFO_COMPLETED:
      return { ...state, vsInfoLoading: false, vsInfo: action.payload }
    case VS_INFO_FAILED:
      return { ...state, vsInfoLoading: false }
    case VS_PLAYER_IDS_UPDATED:
      return { ...state, vsPlayerIds: action.payload }
    default:
      return state
  }
}
